import React from "react";

interface ScrollToBottomProps {
  visible: boolean;
  newMessageCount: number;
  onClick: () => void;
}

export default function ScrollToBottom({ visible, newMessageCount, onClick }: ScrollToBottomProps) {
  return (
    <button
      onClick={onClick}
      className="absolute bottom-4 right-4 z-10 p-2 rounded-full transition-all duration-200"
      style={{
        backgroundColor: "var(--c-surface)",
        border: "1px solid var(--c-border)",
        boxShadow: "var(--c-shadow)",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(8px)",
        pointerEvents: visible ? "auto" : "none",
      }}
      title="Scroll to bottom"
    >
      {newMessageCount > 0 && (
        <span
          className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full text-[9px] font-semibold flex items-center justify-center"
          style={{
            backgroundColor: "var(--c-primary)",
            color: "var(--c-primary-text)",
          }}
        >
          {newMessageCount > 9 ? "9+" : newMessageCount}
        </span>
      )}
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        style={{ color: "var(--c-text-secondary)" }}
      >
        <path d="M4 6l4 4 4-4" />
      </svg>
    </button>
  );
}
